import CurrencyTransactionRate from 'components/new/CurrencyTransactionRate';
import CurrencySaleReview from 'components/new/CurrencySaleReview';
import CurrencyTransactionSummary from 'components/new/CurrencyTransactionSummary';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Typography } from '@mui/material';
import { Row } from 'further-ui/components/Layout';
import { CurrencyTransactionOperation } from 'components/new/CurrencyTransactionSummary/types';

type Props = {
  reconciliationDetails: {
    isForeignCurrencySale: boolean;
    isBankTransfer: boolean;
    sale: {
      total: number;
      currency: CurrencyCode;
      income: number;
      costs: number;
      bankTransactionAmount?: number;
    };
    purchase: {
      total: number;
      currency: CurrencyCode;
      income: number;
      costs: number;
      bankTransactionAmount?: number;
    };
    currencyRate?: {
      sourceCurrency: CurrencyCode;
      targetCurrency: CurrencyCode;
      rate: number;
    };
    foreignCurrencyPurchaseRate: number;
    foreignCurrencySaleGain: {
      gainAmountLcy: number;
    };
  };
};

const MultiCurrencyReview: React.FC<Props> = ({ reconciliationDetails }) => {
  const {
    isForeignCurrencySale,
    isBankTransfer,
    sale,
    purchase,
    currencyRate,
    foreignCurrencyPurchaseRate,
    foreignCurrencySaleGain,
  } = reconciliationDetails;

  return (
    <>
      <Typography variant="h5">
        1. Review foreign exchange transaction
      </Typography>
      <Row fullWidth justify="space-between" spacing="lg">
        {sale && (
          <CurrencyTransactionSummary
            {...sale}
            isTransfer={isBankTransfer}
            operation={CurrencyTransactionOperation.Sale}
          />
        )}
        {currencyRate && <CurrencyTransactionRate {...currencyRate} />}
        {purchase && (
          <CurrencyTransactionSummary
            {...purchase}
            isTransfer={isBankTransfer}
            operation={CurrencyTransactionOperation.Purchase}
          />
        )}
      </Row>
      {isForeignCurrencySale && (
        <CurrencySaleReview
          rootCurrency={purchase.currency}
          saleAmount={sale.total}
          purchaseAmount={purchase.total}
          saleRate={currencyRate?.rate ?? 1}
          purchaseRate={foreignCurrencyPurchaseRate ?? 0}
          foreignCurrencyGain={foreignCurrencySaleGain.gainAmountLcy}
        />
      )}
    </>
  );
};

export default MultiCurrencyReview;
